import { getErrorCode } from '@onefootprint/fetch-hosted';

/**
 * E140: the session's workflow was deactivated because a newer onboarding started for the same
 * user. Retrying with this token can never succeed.
 */
export const isOnboardingSuperseded = (error: unknown): boolean => getErrorCode(error) === 'E140';
